const isDevelopment = process.env.NODE_ENV === 'development';

export const BACKEND_URI = process.env.REACT_APP_BACKEND_URI || 'https://interactive-maps-backend-latest.onrender.com';

console.log('Backend URI:', BACKEND_URI); // For debugging

export const goggleAuthClientID = "781903186448-gn5t8bmk5uuf9s74micvui4qaq5aeg28.apps.googleusercontent.com"
